import { render } from "./CardStats.vue?vue&type=template&id=34589fba"
import script from "./CardStats.vue?vue&type=script&lang=js"
export * from "./CardStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Cards/CardStats.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34589fba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34589fba', __exports__)) {
    api.reload('34589fba', __exports__)
  }
  
  module.hot.accept("./CardStats.vue?vue&type=template&id=34589fba", () => {
    api.rerender('34589fba', render)
  })

}


export default __exports__